import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AgGrid from '../../../shared/displayComponents/agGrid/agGrid.component';
import { fetchGenericSourceData } from '../../../shared/store/genericSourceData/actions';
import {
  genericSourceDataSelector,
  genericSourceDataColumnsSelector,
  isFetchingGenericSourceDataSelector,
} from '../../../shared/store/genericSourceData/selectors';
import { periodSelector, taxYearSelector } from '../../../shared/store/selectors';

import getColumnDefinitions from './genericSourceData.columnDefinitions';

const GenericScreen = ({
  taxYear,
  period,
  orgId,
  jurisdictionId,
  isFetchingContext,
  categoryId,
  accountId,
  componentId,

  genericSourceData,
  genericSourceDataColumns,
  isFetchingGenericSourceData,
  fetchGenericSourceData,
}) => {
  const isContextReady =
    taxYear && period && orgId && jurisdictionId && categoryId && accountId && componentId;

  useEffect(() => {
    if (isContextReady) {
      fetchGenericSourceData({
        taxYear,
        period,
        orgId,
        jurisdictionId,
        categoryId,
        accountId,
        componentId,
      });
    }
  }, [
    isContextReady,
    fetchGenericSourceData,
    taxYear,
    period,
    orgId,
    jurisdictionId,
    categoryId,
    accountId,
    componentId,
  ]);

  const columnDefinitions = useMemo(
    () =>
      getColumnDefinitions({
        genericSourceDataColumns,
      }),
    [genericSourceDataColumns],
  );

  return (
    <div className="row grid-row">
      <div className="col">
        <AgGrid
          rowData={genericSourceData}
          columnDefs={columnDefinitions}
          isGridLoading={isFetchingContext || isFetchingGenericSourceData}
        />
      </div>
    </div>
  );
};

const genericSourceDataPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    accountId: PropTypes.string,
    amount: PropTypes.number,
    sourceUpdatedBy: PropTypes.string,
    sourceUpdatedPh: PropTypes.string,
    sourceUpdatedDate: PropTypes.string,
    sourceFirstName: PropTypes.string,
    sourceLastName: PropTypes.string,
    sourceMiddleInitial: PropTypes.string,
    hoLeid: PropTypes.string,
    hoReportingPeriod: PropTypes.number,
    reportingPeriod: PropTypes.number,
    cdrNo: PropTypes.string,
    scenario: PropTypes.number,
  }),
).isRequired;

const genericSourceDataColumnsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    columnName: PropTypes.string.isRequired,
    columnDesc: PropTypes.string.isRequired,
    formatFlag: PropTypes.string.isRequired,
  }),
).isRequired;

GenericScreen.propTypes = {
  taxYear: PropTypes.string,
  period: PropTypes.string,
  orgId: PropTypes.string,
  jurisdictionId: PropTypes.string,
  isFetchingContext: PropTypes.bool.isRequired,
  categoryId: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  componentId: PropTypes.string.isRequired,

  genericSourceData: genericSourceDataPropTypes,
  genericSourceDataColumns: genericSourceDataColumnsPropTypes,
  isFetchingGenericSourceData: PropTypes.bool.isRequired,
  fetchGenericSourceData: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    taxYear: taxYearSelector(state),
    period: periodSelector(state),
    genericSourceData: genericSourceDataSelector(state),
    genericSourceDataColumns: genericSourceDataColumnsSelector(state),
    isFetchingGenericSourceData: isFetchingGenericSourceDataSelector(state),
  }),
  {
    fetchGenericSourceData,
  },
)(GenericScreen);
